import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { message } from 'antd';
import { validateEnv } from './config/env';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import store from './store';
import './index.css';
import App from './components/app/App';
import Routes from './routes';

// import reportWebVitals from "./reportWebVitals";

/* eslint-disable no-console */
// Validate environment variables before app initialization
try {
  validateEnv();
} catch (error) {
  console.error(error);
}

message.config({
  duration: 5,
  maxCount: 3,
});

// Top-level error boundary to catch all errors
ReactDOM.render(
  <ErrorBoundary showDetails={process.env.NODE_ENV === 'development'}>
    <Provider store={store}>
      <App>
        <Routes />
      </App>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
